// utils && hooks
import { getFieldsByCountry } from '../Inputs';
import { applyCuitMask } from 'utils/inputMasks/applyCuitMask';
// interfaces
import { IUseDocumentationProps } from '../interfaces/DocumentationProps';

const useDocumentation = ({ onChange, country, setErrorResponse }: IUseDocumentationProps) => {
    const { FIELDS } = getFieldsByCountry(country);

    // Manejador de cambio de archivo
    const onFileChange = (file: any, key: number) => {
        if (!file || !file.at(-1)) {
            // Si no hay archivo o el archivo es undefined, eliminamos el archivo correspondiente del estado
            handleChange(null, key);
            return;
        }
        const newFile = { ...file.at(-1), key };
        handleChange(newFile, key);
    };

    // Manejador de cambio de texto para el campo 'Código GLN'
    const onFormInputChange = (value: string, key) => {
        const numericValue = value.replace(/\D/g, '');
        handleChange(numericValue, key);
    };

    const handleChange = (value, key) => {
        const v = key === 'tax_id' && country === 'AR' ? applyCuitMask(value) : value;

        onChange((prevState) => {
            const newValue = typeof v === 'string' && v.trim().length > 0 ? v : !!v ? v : null;

            if (newValue === null) {
                if (key === 'tax_id' || key === 'company_name') {
                    return {
                        ...prevState,
                        [key]: null,
                    };
                } else {
                    const filter = prevState.documents?.filter((doc) => doc.document_type_id !== key);
                    return {
                        ...prevState,
                        documents: filter,
                    };
                }
            } else {
                // Validación para 'tax_id' y 'company_name'
                if (key === 'tax_id' || key === 'company_name') {
                    setErrorResponse((prevState) => {
                        const filteredState = Object.keys(prevState).reduce((acc, currKey) => {
                            // Excluir 'company_name' o 'tax_id'
                            if (currKey !== key) {
                                acc[currKey] = prevState[currKey];
                            }
                            return acc;
                        }, {});
                    
                        return filteredState;
                    });
                    
                    return {
                        ...prevState,
                        [key]: newValue,
                    };
                } else {
                    // Para el resto de las claves, verificamos si existe en documents
                    const existingDocIndex = prevState.documents?.findIndex((doc) => doc.document_type_id === key);

                    if (existingDocIndex !== -1) {
                        const updatedDocuments = [...prevState.documents];
                        updatedDocuments[existingDocIndex] = { file: newValue, document_type_id: key };

                        return {
                            ...prevState,
                            documents: updatedDocuments,
                        };
                    } else {
                        return {
                            ...prevState,
                            documents: [...prevState.documents, { file: newValue, document_type_id: key }],
                        };
                    }
                }
            }
        });

        setErrorResponse((prevState) => {
            // Filtra las claves que coinciden con 'documents.[key]'
            const filteredState = Object.keys(prevState).reduce((acc, currKey) => {
                // Eliminar la clave 'documents.[key]' si existe
                if (!currKey.startsWith(`documents.${key}`)) {
                    acc[currKey] = prevState[currKey];
                }
                return acc;
            }, {});

            return filteredState;
        });
    };

    return { FIELDS, onFileChange, handleChange, onFormInputChange };
};

export default useDocumentation;
